


















import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import Button from "@/components/button/Button.vue";
import localStorageHelper from "@/localstorage/localstorage";
import EventBus from "@/utils/eventBus";
import * as types from "@/store/constants/types";

@Component({
  components: {
    Button
  }
})
export default class RateUsItem extends Vue {
  @Getter(types.GETTER_SETTING_DATA)
  private settingData: any;
  @Action(types.CHECK_GX_USER_LOGINED)
  private checkSignGxUser: any;

  private rateUsShow: boolean = true;

  get rateUsReward() {
    return this.settingData && this.settingData.rate_task ? this.settingData.rate_task.reward : 0;
  }

  private async clickRateUs() {
    const result = await this.checkSignGxUser();
    console.log(result);
    if (!result) {
      return;
    }

    EventBus.$emit("show-rateus-toast", {
      show: true,
      coins: this.rateUsReward
    });
  }

  private mounted() {
    this.rateUsShow = localStorageHelper.has("rate_us") !== true;
    EventBus.$on("hide-rate-us", (val: any) => {
      this.rateUsShow = !val;
    });
  }
  // 每次重新进入
  private activated() {
    //先进coinstore,不rateus，再进get coins页面，成功rateus后，回到conin sotre，需要重新判断
    this.rateUsShow = localStorageHelper.has("rate_us") !== true;
  }
}
